import React from "react";
import { Grid, Button, TextArea, Form, Table } from "semantic-ui-react";

import InvoiceComponentTotals from "../components/totals";
import InvoiceComponentSummary from "../components/summary";
import { InvoiceStatuses } from "utilities/dist/invoice/constants";

const InvoiceBuilderFooterComponent = ({
    note,
    stamps,
    totals,
    company,
    delivery_type,
    status,
    invoice,
    isCancelled,

    editStamp,
    changeNote,
    saveInvoice,
    removeStamp,
    handleCancel,
    userRole,
    editable,
    isStampsOnlyMode,
    disableStampEditIcons = false,
    isSaving,
}) => (
    <Table.Row verticalAlign="top">
        <Table.HeaderCell colSpan={3} verticalAlign="top">
            <Grid>
                <Grid.Column width={8}>
                    <InvoiceComponentSummary
                        totals={totals}
                        stamps={stamps}
                        status={status}
                        onStampEdit={editStamp}
                        onStampRemove={removeStamp}
                        disableStampEdit={disableStampEditIcons}
                        editable={
                            editable ||
                            isStampsOnlyMode ||
                            (userRole === "owner" &&
                                [
                                    InvoiceStatuses.INVOICED,
                                    InvoiceStatuses.DELIVERED,
                                    InvoiceStatuses.PICKED_UP,
                                ].includes(invoice?.status))
                        }
                    />
                </Grid.Column>

                {!isCancelled && (
                    <Grid.Column width={8}>
                        <Form>
                            <Form.Field>
                                <label>Add a note</label>
                                {note ? (
                                    <TextArea
                                        rows={5}
                                        value={note}
                                        onChange={changeNote}
                                        disabled={!editable}
                                    />
                                ) : (
                                    <TextArea rows={5} onChange={changeNote} disabled={!editable} />
                                )}
                            </Form.Field>
                        </Form>
                    </Grid.Column>
                )}
            </Grid>
        </Table.HeaderCell>

        <Table.HeaderCell colSpan={2} textAlign="right" verticalAlign="top">
            <InvoiceComponentTotals
                totals={totals}
                company={company}
                delivery_type={delivery_type}
            />
            {!isCancelled && (
                <div className="tp-10">
                    <Button
                        data-cy="create_invoice"
                        size="small"
                        icon="check"
                        floated="right"
                        disabled={
                            isSaving ||
                            (invoice &&
                                !editable &&
                                !isStampsOnlyMode &&
                                !(
                                    userRole === "owner" &&
                                    [
                                        InvoiceStatuses.INVOICED,
                                        InvoiceStatuses.DELIVERED,
                                        InvoiceStatuses.PICKED_UP,
                                    ].includes(invoice?.status)
                                ))
                        }
                        color={invoice ? "blue" : "green"}
                        content={invoice ? "Save" : "Create"}
                        onClick={() => saveInvoice(invoice || {})}
                    />
                    {!invoice && (
                        <Button
                            color="red"
                            size="small"
                            icon="close"
                            floated="right"
                            content="Reset"
                            onClick={handleCancel}
                        />
                    )}
                </div>
            )}
        </Table.HeaderCell>
    </Table.Row>
);

export default InvoiceBuilderFooterComponent;
